import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appSsMultiselectDropdownTabindexMigrator]'
})
export class SsMultiselectDropdownTabindexMigratorDirective implements OnInit {

  // In our template, we set the tab index on the ss-multiselect-dropdown element, this code
  // will "move" that tabindex to the widget's internal button

  constructor(private el: ElementRef) { }

  ngOnInit() {
    const element = this.el.nativeElement as HTMLElement;
    const $el = $(element);
    if (element.nodeName.toLowerCase() !== 'ss-multiselect-dropdown') {
      console.error('SsMultiselectDropdownTabindexMigratorDirective is on invalid component. Must be on "ss-multiselect-dropdown"');
      return;
    } else if (!$el.attr('tabindex')) {
      console.error('SsMultiselectDropdownTabindexMigratorDirective is on a "ss-multiselect-dropdown" which doesn\'t specify a tabindex.');
      return;
    }

    const multiselectTabIndex = $el.attr('tabindex');
    const multiselectButton = $el.find('button');
    multiselectButton.attr('tabindex', multiselectTabIndex);
    $el.removeAttr('tabindex');
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/ss-multiselect-dropdown-tabindex-migrator.directive.ts